import { Preferences } from '@capacitor/preferences';

interface IPreferences {
	key: string;
	value: string | number | boolean | object | Array<any>;
}

export const setPreference = async (preferences: IPreferences) => {
	// JSON "set" example
	await Preferences.set({
		key: preferences.key,
		value: JSON.stringify(preferences.value),
	});
};

export const getPreference = async (key: string) => {
	const ret = await Preferences.get({ key });
	if (!ret.value) return null;

	return JSON.parse(ret.value);
};

export const removePreference = async (key: string) => {
	await Preferences.remove({ key });
};

//   // JSON "get" example
//   async getObject() {
//     const ret = await Preferences.get({ key: 'user' });
//     const user = JSON.parse(ret.value);
//   }
